import { gql, useMutation } from '@apollo/client';

const GENERATE_DRILL = gql`
  mutation GenerateDrill($input: DrillGenerationInput!) {
    generateDrill(input: $input) {
      drill {
        title
        description
        ageGroup
        duration
        objectives
        equipment
        development {
          step
          description
          duration
        }
        coachingPoints
        variations
        generatedAt
        model
      }
      savedExercise {
        id
        name
        generatedByAI
      }
      quota {
        subscriptionTier
        remainingToday
        remainingThisMonth
        canGenerate
      }
    }
  }
`;

export function useGenerateDrill() {
  const [generateDrillMutation, { data, loading, error }] = useMutation(GENERATE_DRILL);

  const generateDrill = async (options: { variables: { input: any } }) => {
    return generateDrillMutation(options);
  };

  return {
    generateDrill,
    drill: data?.generateDrill?.drill,
    savedExercise: data?.generateDrill?.savedExercise,
    quota: data?.generateDrill?.quota,
    loading,
    error,
  };
}
